const CHATBOT_URL = 'https://teckai.objectit.com.au';

let chatbotLoaded = false;

// Adds the AI chatbot's stylesheet, container and script to the page, once.
export const loadChatbot = () => {
  if (chatbotLoaded) return;
  chatbotLoaded = true;

  const stylesheet = document.createElement('link');
  stylesheet.rel = 'stylesheet';
  stylesheet.href = `${CHATBOT_URL}/embed.css`;
  document.head.appendChild(stylesheet);

  const container = document.createElement('div');
  container.id = 'embedded-container';
  document.body.appendChild(container);

  const script = document.createElement('script');
  script.src = `${CHATBOT_URL}/vue-embed.umd.js`;
  script.onload = () => window.ChatEmbed();
  document.body.appendChild(script);
};



// WEBPACK FOOTER //
// ./src/helpers/chatbot_helpers.js